// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__GBr1N","bigColWidth":"Table_bigColWidth__3M9Jn","biggerColWidth":"Table_biggerColWidth__3T831","row":"Table_row__2TdzI","col":"Table_col__3aWaM"};